import React, { useState } from "react";
import Visualization from "./Visualization";
import warehouseData from "./warehouse_zone_101.json";

function App() {
  const [selectedZone, setSelectedZone] = useState(null);

  const handleZoneClick = (zone) => {
    setSelectedZone(zone);
  };

  const handleBackClick = () => {
    setSelectedZone(null);
  };

  return (
    <div>
      <h1>Wizualizacja Magazynu</h1>
      {selectedZone ? (
        <>
          <button onClick={handleBackClick}>Powrót</button>
          <Visualization data={selectedZone} />
        </>
      ) : (
        <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
          {warehouseData.warehouse.map((zone) => (
            <div
              key={zone.zone}
              onClick={() => handleZoneClick(zone)}
              style={{
                width: "150px",
                height: "150px",
                backgroundColor: "#f0f0f0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "1px solid #ccc",
                cursor: "pointer",
                borderRadius: "10px",
              }}
            >
              <h2>Strefa {zone.zone}</h2>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default App;
